import { render, staticRenderFns } from "./WebrtcVideo.vue?vue&type=template&id=ba266180&"
import script from "./WebrtcVideo.vue?vue&type=script&lang=js&"
export * from "./WebrtcVideo.vue?vue&type=script&lang=js&"
import style0 from "./WebrtcVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports